import React, { useState, useEffect, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import AssistantModal from './assistant/AssistantModal';
import { getPageMeta } from '../config/pageMeta';
import { renderToStaticMarkup } from 'react-dom/server';

/** Fare tekerleği ile kaydırmayı koruyup scrollbar çubuğunu gizlemek için (WebKit / Firefox). */
const mainNoScrollbarTrim =
  '[scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden';
const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const pageMeta = useMemo(() => getPageMeta(location.pathname), [location.pathname]);
  const isCheckCreditActivityReportRoute = location.pathname.includes('/reports/check-credit-activity');

  useEffect(() => {
    const baseTitle = 'JANSOFT ERP';
    const title = pageMeta?.title ? `${pageMeta.title} | ${baseTitle}` : baseTitle;
    document.title = title;

    const ensureFaviconLink = () => {
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      return link;
    };

    const favicon = ensureFaviconLink();
    if (pageMeta?.icon) {
      const svgMarkup = renderToStaticMarkup(
        React.createElement(pageMeta.icon, {
          size: 32,
          strokeWidth: 1.8,
          color: '#2563eb'
        })
      );
      favicon.type = 'image/svg+xml';
      favicon.href = `data:image/svg+xml,${encodeURIComponent(svgMarkup)}`;
    } else {
      favicon.href = '/favicon.ico';
    }
  }, [pageMeta]);

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      {/* Sidebar */}
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
      
      {/* Main content */}
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        {/* Header */}
        <Header onMenuClick={() => setSidebarOpen(true)} />
        
        {/* Page content */}
        <main
          className={`flex min-h-0 flex-1 flex-col overflow-x-hidden overflow-y-auto bg-gray-50 p-4 dark:bg-gray-900 ${
            isCheckCreditActivityReportRoute ? mainNoScrollbarTrim : ''
          }`}
        >
          <div
            className={`mx-auto w-full max-w-[110rem] ${
              isCheckCreditActivityReportRoute ? 'flex min-h-0 flex-1 flex-col' : ''
            }`}
          >
            <Outlet />
          </div>
        </main>
      </div>
      <AssistantModal />
    </div>
  );
};

export default Layout;
